<div class="loading-wrapper" [ngClass]="{ global, loading }">
  <img src="./assets/img/layout/loading.svg" alt="Loading" class="loading-image" />
</div>
